/**
 * Native replacement for lodash/fp `clone` (shallow). Returns a shallow copy of
 * arrays and plain objects; returns primitives (and other values) unchanged.
 */
export default function clone<T>(value: T): T {
    if (Array.isArray(value)) return [...value] as T;
    if (value !== null && typeof value === 'object') return { ...value } as T;
    return value;
}
